<template>
  <div class="appeals-layout">
    <button type="button"
            class="btn btn-light btn-sm mt-2 mt-md-0"
            v-if="(isTherapist || isBCBA || isCurator) && client"
            @click.prevent="backToPreviousPage()">
      <i class="material-icons mdc-button__icon">arrow_back</i>
      <span v-if="clientId">{{'buttons.back_to_client' | trans}} {{client.code}} ({{client.hash}})</span>
      <span v-else>{{'buttons.back' | trans}}</span>
    </button>

    <div class="pt" v-if="client || (isClient && clientTimezone)">
      <h1 class="title">{{'appeals.appeals_for_period' | trans }}</h1>
      <appeals-list :clientId="clientId" :clientTimezone="clientTimezone"></appeals-list>
    </div>

    <dashboard-menu v-if="!isClient"></dashboard-menu>
  </div>
</template>

<script>
  import axios from 'axios';
  import AppealsList from '../../appeals/components/AppealsList';
  import DashboardMenu from '../../dashboardParent/components/DashboardMenu';
  import Auth from '../../../common/auth/Manager';
  import {mapState, mapGetters} from 'vuex';
  import {pagination} from '../../../common/mixins/pagination';

  export default {
    name: 'appealsLayout',

    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return Auth.getUserInfo().id || this.route.params.clientId;
        },
      }
    },

    data() {
      return {
        isOpen: false,
        client: null,
        clientApiUrl: '/users/clients/'
      };
    },

    computed: {
      ...mapGetters('auth', [
        'getUserInfo',
        'isBCBA',
        'isTherapist',
        'isCurator',
        'isClient',
        'user'
      ]),
      ...mapState(['route']),
      isEmptyClient() {
        return isEmpty(this.client);
      },
      clientTimezone() {
        if (!this.isClient) {
          return this.client.timezone;
        }
        else {
          return this.user.timezone
        }
      }
    },

    mixins: [pagination],

    components: {
      AppealsList, DashboardMenu
    },

    created() {
      if (!this.isClient) {
        this.getClient(this.clientId);
      }
    },

    methods: {
      getClient: async function (clientId) {
        try {
          let response = await axios.get(this.clientApiUrl + clientId);
          this.client = response.data.data;
        } catch (error) {
          console.dir(error)
        }
      },
      backToPreviousPage() {
        this.$router.push({name: 'client-edit', params: {clientId: this.client.id}});
      },
    }
  };

</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/AppealsLayout.vue